import useSWR from "swr";
import fetcher from "../../lib/fetcher";
import {
  EDealRequestStatus,
  EDealRequestType,
  IMinifiedUserSchema,
} from "../../interfaces";
import { EDealRequestLinkType } from "./use-deal-request-exchange";

export interface IDealRequestsResponseSchema {
  id: number;
  type: EDealRequestType;
  title: string;
  status: EDealRequestStatus;
  manager?: IMinifiedUserSchema;
  link?: LinkDealRequestsSchema
  createdAt: Date
}

export interface LinkDealRequestsSchema {
  id: number;
  linkType: EDealRequestLinkType;
  dealRequestIds: number[];
}

export type IDealRequestsResponseSchemaWrapper = {
  data: IDealRequestsResponseSchema[];
};

const useDealList = () => {
  const { data, error, isLoading, mutate } =
    useSWR<IDealRequestsResponseSchemaWrapper>(
      `/deal-request/summary`,
      fetcher.swr
    );

  return {
    dealList: data?.data ?? [],
    error,
    isLoading,
    mutate,
  };
};

export default useDealList;
